/**
 * @ngdoc service
 * @name guestlists.factory:Guestlist
 *
 * @description
 *
 */
angular
    .module('festzelt-os.guestlists')
    .factory('GuestlistShift', ['Resource', GuestlistShift]);

function GuestlistShift(Resource) {
    const $model = Resource.make('guestlists');

    $model.title = ' Guestlist Shifts';

    $model.locales = ['guestlists'];

    return $model;
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/factories/guestlist/guestlist-shift-factory.js